import React from "react";
import type { LegalNode } from "./documents";

const TAGS = new Set(["h2", "h3", "p", "ul", "ol", "li", "strong", "em", "br", "hr"]);

// Renders the static document tree as React elements; only whitelisted tags are emitted, no raw HTML is injected.
function render(nodes: LegalNode[]): React.ReactNode[] {
  return nodes.map((n, i) => {
    if (typeof n === "string") return n;
    if (!TAGS.has(n.t)) return null;
    return React.createElement(n.t, { key: i }, ...(n.c ? render(n.c) : []));
  });
}

export default function LegalDocument({ nodes }: { nodes: LegalNode[] }) {
  // The page supplies its own <h1>, so the document's leading heading is skipped.
  const body = nodes.filter((n) => !(typeof n !== "string" && n.t === "h1"));
  return <>{render(body)}</>;
}
